import * as React from "react";
import { ReviewStatusBadge } from "./ReviewStatusBadge";
import { REVIEW_SENTIMENT_CONFIG, type ReviewSentimentFilter } from "./ReviewSentimentFilterButtons";

type ReviewSentimentBadgeProps = {
  sentiment: ReviewSentimentFilter;
  className?: string;
};

export function ReviewSentimentBadge({ sentiment, className }: ReviewSentimentBadgeProps) {
  const config = REVIEW_SENTIMENT_CONFIG[sentiment];
  if (!config) return null;

  return <ReviewStatusBadge label={config.title} icon={config.Icon} tone={config.tone} className={className} />;
}
